import React from 'react'
import classNames from 'classnames'
import moment from 'moment'
import _ from 'lodash'
import ScrollArea from 'react-scrollbar'

import {ChatList} from './chatlist.component'
import {HashTag, DeepLink} from '../services/hashtag'
import {URLHash} from '../services/router/router'


export class ChatSidebar extends React.Component {
    constructor(props) {
        super(props)

        this._forceOpen = false

        this.state = {
            message: '',
            unseen: 0,
            mountedAt: moment() // not sure if we'll use this. seems to be updating all the time
        }

        _.bindAll(this,
            'updateMessage',
            'scrollElement'
        )
    }

    scrollElement() {
        let _this = this
        window.requestAnimationFrame(function() {
            let node = _this.refs.scrollArea
            if (node !== undefined) {
                node.scrollYTo(node.state.realHeight)
            }
        })
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.chat.size > this.props.chat.size) {
            if (nextProps.activeMenuItem !== 'chat' && this.props.activeMenuItem !== 'chat') {
                let diffSize = nextProps.chat.size - this.props.chat.size
                if (diffSize > 1) {
                    // assumption is we're always getting chats one at a time...
                    // console.log("NOT SURE HOW THAT HAPPENED?")
                } else {
                    // so get the chat from the end of the list
                    let newChat = nextProps.chat.last()

                    // if message contains /open, force it open?
                    if ( newChat.get('message').indexOf('/force') > -1) {
                        // console.log('force it')
                        this.props.updateActiveMenuItem('chat')
                    }


                    // make sure that the user didn't send the chat (like from another tab)
                    // and that the timestamp is after they loaded the page
                    // TODO: we probably want to have their last activity timestamp from the last time they logged in?          
                    if (
                        this.props.currentUser.guid !== newChat.get('sender_guid') &&
            this.state.mountedAt.isBefore(moment(newChat.get('created_at')))
            // moment(this.state.mountedAt).diff(moment(newChat.get('created_at')), 'seconds') < 0
                    ) {
                        // console.log("you haven't seen this!")
                        // console.log(newChat)
                        let newUnseen = this.state.unseen + 1
                        this.setState({unseen: newUnseen})
                        this.props.updateUnseenChats(newUnseen)            
                    } else {
                        // console.log("too old?")
                    }
                }
            } else {
                // you have the window open, so we should make sure it's zero just in case
                this.setState({unseen: 0})
                this.props.updateUnseenChats(0)
            }      
        }

        if (this.props.activeMenuItem !== 'chat' && nextProps.activeMenuItem === 'chat') {
            // opening chat, so let's zerp out the chats
            this.setState({unseen: 0})
            this.props.updateUnseenChats(0)
        }

    // should also check to make sure if we're opening the chat window that we zero out the unseen
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.chat.size !== prevProps.chat.size || this.props.activeMenuItem === 'chat' && prevProps.activeMenuItem !== 'chat') {
            // if(!this._forceOpen && this.props.activeMenuItem !== 'chat'){
            //   this._forceOpen = true
            //   this.props.updateActiveMenuItem('chat')
            // }
            this.scrollElement()
        }
    }

    updateMessage(evt) {
        if (evt.target.value == '/help') {
            this.helperMessage()
        } else {
            this.setState({
                message: evt.target.value
            })
        }
    }

    generateHash() {
    // generate the hashtag    
        let curHash = window.location.hash
        let hashToSegments = URLHash.parse(curHash)
        let curDeepLink = DeepLink.parse(hashToSegments)

        // try to make sense of the segments to create a name
        let hashName = {
            destination: '',
            obj: '',
            section: '',
            subsection: ''
        }
        let _this = this
        _.each(hashToSegments, function(seg) {
            if (seg.type == 'leg') {
                // look for a destination in the leg
                let curLeg = _this.props.legs.filter((leg) => {                
                    return leg.get('id') === seg.identifier
                })              

                let curDest = curLeg.getIn([0, 'destination', 'title']) ? curLeg.getIn([0, 'destination', 'title']) : ''
                if (typeof curDest != 'undefined') {
                    hashName.destination = curDest
                }
            } else if (seg.type == 'uistatus') {
                // check to see if details
                let sections = seg.identifier.split('~')
                hashName.section = sections[0]
                hashName.subsection = sections[1]
                // otherwise mark section
            } else if (seg.type == 'accommodation') {
                let accom = null
                let leg = _this.props.legs.find((leg) => {
                    let accoms = leg.getIn(['accommodations'])
                    accom = accoms.find((accom) => {
                        return accom.get('accommodation_guid') === seg.identifier
                    })
                    if (accom) {
                        return leg
                    }
                })
                if (leg) {                
                    hashName.obj = accom.get('name')
                }              
            } else if (seg.type == 'activity') {
                let act = null
                let leg = _this.props.legs.find((leg) => {
                    let acts = leg.getIn(['activities'])
                    act = acts.find((act) => {
                        return act.get('place_id') === seg.identifier
                    })
                    if (act) {
                        return leg
                    }
                })
                if (leg) {                
                    hashName.obj = act.get('name')
                }
            }
        })
        let hashTitle = ''
        if (hashName.subsection == 'details' && hashName.obj != '') {
            hashTitle = hashName.obj + ' (' + hashName.destination + ')'
        } else {
            hashTitle = hashName.destination + ' ' + hashName.section
        }

        if (hashTitle.trim() == '') {
            hashTitle = this.props.tripName
        }

        return HashTag.new(hashTitle, curDeepLink).serialize()
    }

    render() {
        let onEnterKeyPress = (evt) => {
            if (evt.key === 'Enter') {
                evt.preventDefault()
                evt.stopPropagation()

                if (!this.state.message) {
                    return
                } else {
                    let hashTag = this.generateHash()

                    let parseMentions = []
                    let lunaIndex = this.state.message.toLowerCase().indexOf('@luna')
                    if (lunaIndex >= 0) {
                        parseMentions = [
                            {
                                handle: '@luna',
                                mention_index: lunaIndex,
                                at_luna: true
                            }
                        ]
                    }
          
                    this.props.onChatSend(
                        this.props.tripGuid,
                        this.state.message,
                        this.props.currentUser.guid,
                        // `#${_.camelCase(this.props.tripName)}`,
                        hashTag,
                        parseMentions,
                        moment.utc()
                    )

                    this.setState({message: ''})
                }
            }    
        }

        let classes = classNames(
            'widget-popup',
            {'active': this.props.activeMenuItem === 'chat'}
        )

        return (
            <div id="sidebar-chat" className={classes}>
                <div className="widget-header-block">
                    <i className="icon-close" onClick={() => {this.props.updateActiveMenuItem(null)}}/>
                </div>
                <div id="chat-block">
                    <div id="chat-list-wrapper">
                        <ScrollArea
              ref="scrollArea"
              speed={0.8}
              className="area"
              contentClassName="chat-content"
              horizontal={false}>
                            <div id="chat-helper">
                                <h2>Welcome to Luna chat!</h2>
                                <p>Enter a message in the field below</p>
                                <p>To ask Luna a question directly, just start your message with <strong>@Luna</strong></p>
                            </div>
                            <ChatList {...this.props}/>
                        </ScrollArea>
                    </div>
                </div>
                <div id="chat-input-block">
                    <textarea
              className="chat-input"
              type="text"
              placeholder=" Enter your text here..."
              value={this.state.message}
              onChange={this.updateMessage}
              onKeyPress={onEnterKeyPress}/>
                </div>
            </div>
        )
    }
}
